import styled from 'styled-components';

/** TODO: Color to theme */
export const AppBarStyled = styled.div`
    grid-area: appBar;
    /* background-color: ${({ theme }) => theme.branding.gray.dark}; */
    background-color: #2196f3;
    color: white;
    ${({ theme }) => theme.mixins.gridColumnCenter};
    padding: 0 2rem;
    justify-content: flex-end;
    gap: 2rem;
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr max-content max-content max-content;
`;

export const AppBarTitleWrapper = styled.span`
    justify-self: flex-start;
`;
